import { c as _c } from "react/compiler-runtime";
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { motion } from 'framer-motion';
import { forwardRef, type ReactNode } from 'react';
type TooltipWrapperProps = {
  children: ReactNode;
  tooltipContent: ReactNode;
  disableHoverable?: boolean;
  offset?: number;
};
const TooltipWrapper = forwardRef<HTMLDivElement, TooltipWrapperProps>((t0, ref) => {
  const $ = _c(18);
  const {
    children,
    tooltipContent,
    disableHoverable: t1,
    offset: t2
  } = t0;
  const disableHoverable = t1 === undefined ? false : t1;
  const offset = t2 === undefined ? 4 : t2;
  let t3;
  if ($[0] !== children) {
    t3 = <RadixTooltip.Trigger asChild={true}>{children}</RadixTooltip.Trigger>;
    $[0] = children;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0
    };
    t5 = {
      opacity: 1
    };
    t6 = {
      opacity: 0
    };
    t7 = {
      duration: 0.1
    };
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== ref || $[7] !== tooltipContent) {
    t8 = <motion.div ref={ref} initial={t4} animate={t5} exit={t6} transition={t7} className="z-50 transform-gpu flex items-center gap-2 px-2 py-1 border rounded-default shadow-sm bg-primary text-secondary text-label-3 border-tertiary">{tooltipContent}</motion.div>;
    $[6] = ref;
    $[7] = tooltipContent;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== offset || $[10] !== t8) {
    t9 = <RadixTooltip.Portal><RadixTooltip.Content side="right" sideOffset={offset} asChild={true}>{t8}</RadixTooltip.Content></RadixTooltip.Portal>;
    $[9] = offset;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t3 || $[13] !== t9) {
    t10 = <RadixTooltip.Root>{t3}{t9}</RadixTooltip.Root>;
    $[12] = t3;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== disableHoverable || $[16] !== t10) {
    t11 = <RadixTooltip.Provider delayDuration={0} disableHoverableContent={disableHoverable}>{t10}</RadixTooltip.Provider>;
    $[15] = disableHoverable;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
});
TooltipWrapper.displayName = 'TooltipWrapper';
export default TooltipWrapper;